import React, { useEffect } from 'react'
import { GlobalStyle } from './style'
import LanguageProvider from 'components/LanguageProvider'
import { Redirect, Route, Switch } from 'react-router-dom'
import { PrivateRoute } from 'components/PrivateRoute'
import Login from '../Login'
import Orders from '../Orders'
import Return from '../Return'
import Reclamation from '../Reclamation'
import Shipping from '../Shipping'
import Refund from '../Refund'
import { useDispatch, useSelector } from 'react-redux'
import { getLocale, getProperties, logout } from 'store/root-thunk'
import { isAuth } from 'utils/auth'
import { getUrlParameter, SS } from 'utils/common'
import { getLogin, getLoginToken } from '../Login/thunk'
import Exchange from '../Exchange'
import Header from 'components/Header'
import { ThemeProvider } from 'styled-components'
import { push } from 'connected-react-router'
import { cleanItems } from '../../components/Steps/slices'
import { PopupWindow } from 'components/Modal'
import { showPopup, hidePopup } from 'components/Modal/slices'
import { merchantThemes } from '../../components/Variable'
import { HeaderLogout } from '../../components/Header/style'
import { Icon } from 'components/Icon'
import jwt_decode from 'jwt-decode'

const App = (props) => {
	const dispatch = useDispatch()
	const {
		shopId,
		locale,
		messages,
		orderId,
		email,
		shopProperties,
		currentTheme,
		modeApp,
		flowStep,
		wrapperUrl,
		managerUsername,
	} = useSelector((state) => state.root)
	const { isVisible } = useSelector((state) => state.popup)
	const shopLanguage = locale || shopProperties['shop.language'] || 'en'
	const returnadoToken = getUrlParameter('returnadoToken')
	const isShopIdFromTokenActual = (tokenData, currentShopId) => {
		let { shopId } = tokenData ? tokenData.customer : {}
		let shopIdLength = shopId.toString().length
		let isShopValid = false

		switch (shopIdLength) {
			case 1:
				return currentShopId === shopId
				break
			case 4:
				let array1 = currentShopId.toString().split('')
				let array2 = shopId.toString().split('')
				return array1[0] === array2[0]
				break
			case 5:
				let array3 = currentShopId.toString().split('')
				let array4 = shopId.toString().split('')
				let id1
				let id2

				if (parseInt(array3[1]) === 0 && parseInt(array4[1]) === 0) {
					id1 = array3[0]
					id2 = array4[0]
				} else {
					id1 = array3[0] + array3[1]
					id2 = array4[0] + array4[1]
				}
				return id1 === id2
				break
		}

		return isShopValid
	}

	useEffect(() => {
		window.addEventListener(
			'message',
			(event) => {
				if (event.data === 'CLOSE_RETURNADO_WIDGET') {
					dispatch(logout())
					dispatch(cleanItems())
				}
			},
			false
		)
		window.addEventListener(
			'message',
			(event) => {
				if (event.data === 'DESTROY_RETURNADO_WIDGET') {
					SS.clear()
					dispatch(logout())
					dispatch(cleanItems())
				}
			},
			false
		)
		window.addEventListener(
			'message',
			(event) => {
				if (event.data === 'REOPEN_RETURNADO_WIDGET') {
					dispatch(push('/orders'))
				}
			},
			false
		)
		return () => {
			window.removeEventListener(
				'message',
				(event) => {
					if (event.data === 'CLOSE_RETURNADO_WIDGET') {
						dispatch(logout())
						dispatch(cleanItems())
					}
				},
				false
			)
		}
	}, [])

	useEffect(() => {
		if (isAuth() && flowStep === 'SELECT') {
			dispatch(push('/orders'))
		}
	}, [isAuth()])

	/**
	 * getLoginToken {Function}
	 * @description
	 * - check if in url we have returnadoToken, we set token in SS
	 * */
	useEffect(() => {
		if (email && orderId && locale && shopId) {
			let dataLogin = {
				email: email.replace(/\+/g, '%2B'),
				orderId: orderId.replace(/\#/, '%23'),
				language: locale,
				shopId: shopId,
			}
			if (managerUsername) {
				dataLogin.managerUsername = managerUsername
			}
			dispatch(getLogin(dataLogin))
		}
		if (!!returnadoToken) {
			let tokenData = JSON.parse(jwt_decode(returnadoToken)?.sub)

			if (isShopIdFromTokenActual(tokenData, shopId)) {
				dispatch(getLoginToken(returnadoToken))
				dispatch(push('/orders'))
			} else {
				dispatch(
					showPopup({
						type: 'incorrectShopId',
					})
				)
			}
		}
	}, [])

	useEffect(() => {
		if (shopId) {
			dispatch(getProperties(shopId))
			SS.set('shopId', shopId)
		}
	}, [shopId])

	/**
	 * getLocale {Function}
	 * @description
	 * - check if there is a language and make a request for localization
	 * */
	useEffect(() => {
		if (shopId && !messages[shopLanguage] && shopLanguage) {
			SS.set('shopId', shopId)
			SS.set('language', shopLanguage)
			dispatch(getLocale(shopId, shopLanguage))
		}
	}, [shopId, messages, shopLanguage])

	useEffect(() => {
		let loginOrderId = getUrlParameter('loginOrderId')
		if (shopProperties && shopProperties['inspectlet.enabled'] === 'true') {
			console.log('init inspectlet')
			window.__insp = window.__insp || []
			window.__insp.push(['wid', 465103415])
			var ldinsp = function () {
				if (typeof window.__inspld != 'undefined') return
				window.__inspld = 1
				var insp = document.createElement('script')
				insp.type = 'text/javascript'
				insp.async = true
				insp.id = 'inspsync'
				insp.src =
					('https:' === document.location.protocol
						? 'https'
						: 'http') +
					'://cdn.inspectlet.com/inspectlet.js?wid=465103415&r=' +
					Math.floor(new Date().getTime() / 3600000)
				var x = document.getElementsByTagName('script')[0]
				x.parentNode.insertBefore(insp, x)
			}
			setTimeout(ldinsp, 0)
		}
		if (loginOrderId) {
			SS.set('loginOrderId', loginOrderId.replace('%23', '#'))
		}
	}, [])

	useEffect(() => {
		if (
			currentTheme &&
			currentTheme.name &&
			currentTheme.name !== merchantThemes.default
		) {
			let metaProperties = [
				'og:url',
				'og:type',
				'og:title',
				'og:description',
				'og:image',
			]
			let headTag = document.getElementsByTagName('head')[0]
			let getMetaContent = (prop) => {
				switch (prop) {
					case 'og:title':
						return `${currentTheme.name} return service`
					case 'og:description':
						return `Return your items to ${currentTheme.name} via Returnado`
					case 'og:type':
						return `Service`
					case 'og:image':
						return shopProperties['shop.logo.url']
					case 'og:url':
						return 'https://returnado.com/'
				}
			}
			metaProperties.forEach((prop) => {
				let currentMeta = document.getElementById(prop)
				if (currentMeta) {
					currentMeta.parentNode.removeChild(currentMeta)
				}

				let meta = document.createElement('meta')
				meta.setAttribute('id', prop)
				meta.setAttribute('property', prop)
				meta.setAttribute('content', getMetaContent(prop))
				headTag.appendChild(meta)
			})
		}
	}, [currentTheme])

	const handlerLogout = () => {
		// if (wrapperUrl) {
		// 	window.top.postMessage('logout', wrapperUrl)
		// }
		dispatch(logout())
		dispatch(cleanItems())
	}

	return messages[shopLanguage] ? (
		<ThemeProvider theme={currentTheme}>
			<Header modeApp={modeApp} wrapperUrl={wrapperUrl} />
			<HeaderLogout onClick={handlerLogout} modeApp={modeApp}>
				<Icon component='close' />
			</HeaderLogout>
			<LanguageProvider>
				<PopupWindow
					open={isVisible}
					closeOnDocumentClick
					onClose={() => {
						dispatch(hidePopup())
					}}
				/>
				<GlobalStyle />
				<Switch>
					<Route exact path='/login' component={Login} />
					<PrivateRoute exact path='/orders' component={Orders} />
					<PrivateRoute
						exact
						path='/return/:itemIndex?'
						component={Return}
					/>
					<PrivateRoute
						exact
						path='/complaint/:itemIndex?'
						component={Reclamation}
					/>
					<PrivateRoute exact path='/exchange' component={Exchange} />
					<PrivateRoute exact path='/shipping' component={Shipping} />
					<PrivateRoute exact path='/refund' component={Refund} />
					<Redirect
						to={
							isAuth() && modeApp === 'modal'
								? '/orders'
								: '/login'
						}
					/>
				</Switch>
			</LanguageProvider>
		</ThemeProvider>
	) : (
		<div>...Loading</div>
	)
}

export default App
